import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

function formatDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("pc_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatDetail(err.response?.data?.detail) || err.message);
    }
    setBusy(false);
  };

  const inputCls =
    "w-full border border-slate-300 bg-white px-4 py-3.5 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-pool transition-colors";

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white" data-testid="admin-login-page">
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1782714049148-f0b2c07c0b68?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Poolside"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-950/40" />
        <div className="absolute bottom-12 left-12">
          <p className="text-white/70 text-xs tracking-[0.3em] uppercase font-semibold">Poolside Cooking</p>
          <p className="mt-3 font-display font-bold text-white text-3xl">Team Dashboard</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <img src="/logo.png" alt="Poolside Cooking" className="h-14 w-auto mb-10" />
          <h1 className="font-display font-bold text-3xl text-slate-900">Admin sign in</h1>
          <p className="mt-2 text-sm text-slate-500">Manage the Poolside Cooking website.</p>

          {error && (
            <p className="mt-6 bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3" data-testid="admin-login-error">
              {error}
            </p>
          )}

          <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mt-8 mb-2">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
            placeholder="you@poolsidecooking.com"
            data-testid="admin-email-input"
          />

          <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mt-5 mb-2">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
            placeholder="••••••••"
            data-testid="admin-password-input"
          />

          <button
            type="submit"
            disabled={busy}
            className="mt-8 w-full bg-slate-950 hover:bg-pool disabled:opacity-60 text-white text-xs tracking-[0.18em] uppercase font-semibold px-8 py-4 transition-colors"
            data-testid="admin-login-submit"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>

          <a href="/" className="mt-6 inline-block text-xs text-slate-400 hover:text-pool tracking-[0.15em] uppercase transition-colors" data-testid="admin-back-to-site">
            Back to site
          </a>
        </form>
      </div>
    </div>
  );
}
